<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ professional.id ? "Editar" : "Novo" }} Profissional
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="Name">
                    <span class="required">*</span> Nome:
                  </label>
                  <input
                    autocomplete="new-password"
                    type="text"
                    id="Name"
                    class="form-control"
                    v-model="professional.name"
                    placeholder=""
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="EmailDomain">CBO:</label>
                  <v-select
                    :options="cbos"
                    :reduce="(cbos) => cbos.id"
                    :label="'cbo_name'"
                    v-model="professional.cbo_id"
                    class="vselect"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="inputUser">
                    <span class="required">*</span> Status:
                  </label>
                  <select v-model="professional.status" class="form-control">
                    <option :value="1">Ativo</option>
                    <option :value="0">Inativo</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label> Celular</label>
                  <input
                    v-model="professional.phone"
                    type="text"
                    class="form-control"
                    v-mask="'(99) 99999-9999'"
                  />
                </div>
              </div>
              <span class="required_fields">
                <span class="required">*</span>
                <strong>Campos obrigatórios</strong>
              </span>
              <div class="block text-right mb-1">
                <router-link to="/professionals" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <a v-if="$hasAbility('profissional.gerenciar')" class="btn btn-add ml-1" @click="save">
                  Salvar
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  name: "imageUpload",
  data() {
    return {
      professional: {
        cbo_id: null,
        name: "",
        requester_id: null,
        phone: "",
        status: "1",
      },
      cbos: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "professionals";

      if (self.professional.id) {
        api += "/" + self.professional.id;
        self.professional._method = "PUT";
      }

      self.$loading(true);

      self.$http
        .post(api, self.professional)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success",
          );
          self.$loading(false);
          this.$router.push("/professionals");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getCbo: function () {
      const self = this;
      let api = self.$store.state.api + "cbos?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.cbos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProfessional: function (id) {
      const self = this;
      const api = self.$store.state.api + "professionals/" + id;
      self.$loading(true);

      self.$http
        .get(api)
        .then((response) => {
          self.professional = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getCbo();

    if (id) {
      self.getProfessional(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
